import type { MillsheetFieldsFragment, MillsheetItemFieldsFragment } from '@mbfab/client-api'

//
// ホーム（ミルシート一覧）画面共通の型。
// v1 apps/frontend/client/src/components/millsheet/MillsheetsTable.tsx の
// MillsheetsTableRecord / MillsheetsTableColumnKey の移植。
//

export type MillsheetItemRow = MillsheetItemFieldsFragment & {
  // 明細の絞り込み条件に一致するかどうか。展開行のハイライト表示にのみ使う
  // （filter-state.ts の applyMillsheetFilter が計算する。行自体はマッチ有無に関わらず残る）
  isMatched: boolean
}

export type MillsheetRow = Omit<MillsheetFieldsFragment, 'millsheetItems'> & {
  millsheetItems: MillsheetItemRow[]
  // 明細（規格・形状・寸法）は本来ミルシートに紐づく値として扱いたいが、スキーマ上は
  // 明細側にしか無いため、ここで一覧表示用にユニーク化して持たせる（v1 と同じ設計）
  steelTypes: string[]
  sectionTypes: string[]
  sizes: string[]
  totalWeight: number
  // 発注照合（大和ハウス向け）で紐付いている発注の参照番号。fetchMillsheets だけが取得するため
  // MillsheetFields には含まれておらず、任意項目として足している（未紐付け・機能OFFでは null）
  steelOrderReferenceNumber?: string | null
}

export type MillsheetColumnKey =
  | 'manufacturerName'
  | 'issuedDate'
  | 'no'
  | 'steelTypes'
  | 'sectionTypes'
  | 'sizes'
  | 'totalWeight'
  | 'fileUrl'
  | 'attachmentFileUrl'
  | 'shearingCertificateFileUrl'
  | 'actions'
  | 'tradingCompany'
  | 'customer'
  | 'constructionArea'
  | 'member'
  | 'buildingPart'
  | 'constructionName'
  | 'orderNumber'
  | 'innerNo'
  | 'submissionDate'
  | 'steelOrder'

export const MILLSHEET_COLUMN_LABELS: Record<MillsheetColumnKey, string> = {
  manufacturerName: 'メーカー名',
  issuedDate: '発行日',
  steelTypes: '規格',
  sectionTypes: '形状',
  sizes: '寸法',
  totalWeight: '合計重量',
  fileUrl: 'PDF',
  attachmentFileUrl: '添付資料',
  shearingCertificateFileUrl: '剪断証明書',
  tradingCompany: '商社',
  customer: '需要家',
  constructionName: '工事名称',
  constructionArea: '工区',
  member: '節',
  buildingPart: '部位',
  no: '証明書番号',
  orderNumber: '注文番号',
  innerNo: '内部番号',
  submissionDate: '提出日',
  steelOrder: '発注',
  actions: '',
}

// 一括操作の実行結果。成功はトーストのみで伝え、失敗理由だけ DOM に残す
// （2026/08/30 FB「結果パネルは基本消してほしい。toast で十分」。
// docs/develop/client_ui/screens/states.md「操作の結果は「成功はトースト、失敗はトーストと画面の両方」」。lib/run-mutation.ts の MutationFeedback と同じ形）
export type Feedback = { type: 'error'; message: string }
